import { manageServiceLink } from 'Helpers/helpers'
import { store } from '@/store/store'

export default {
  accept: 'accept',
  reject: 'reject',
  resend: 'resend',
  revoke: 'revoke',
}

export function link (service_id) {
  const serviceGetter = store.getters.services

  const service = serviceGetter.find(service => service.id === service_id)
  if (!service) {
    return false
  } else {
    return manageServiceLink(service)
  }
}
